import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgGoogleBusinessProfileLogoSmall = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.58 6.693H4.07a.495.495 0 0 0-.496.496v8.356c0 .274.222.495.495.495h11.51a.495.495 0 0 0 .495-.495V7.189a.495.495 0 0 0-.495-.496Z"
        fill="#4989F5"
      />
      <path
        d="M15.435 6.624H4.201c-.348 0-.619 2.693-.619 3.041l6.152 6.376h5.701c.35-.001.632-.284.633-.633V7.256a.635.635 0 0 0-.633-.632Z"
        fill="url(#src__com__yext__listingslaunchstorm__public__icons__google-business-profile-logo-small_svg__a)"
      />
      <path d="M6.43 8.259H10V3.57H6.964L6.43 8.26Z" fill="#3C4BA6" />
      <path
        d="M13.571 8.259H10V3.57h3.037l.534 4.688ZM16.088 4.46l.017.051c-.004-.018-.012-.034-.017-.05Z"
        fill="#7BABF7"
      />
      <path
        d="m16.08 4.476-.005-.016a1.13 1.13 0 0 0-1.103-.889h-1.935l.534 4.688h3.572l-1.064-3.783Z"
        fill="#3F51B5"
      />
      <path
        d="m3.952 4.46-.016.051c.004-.018.012-.034.016-.05Z"
        fill="#7BABF7"
      />
      <path
        d="m3.922 4.476.004-.016a1.13 1.13 0 0 1 1.103-.889h1.935L6.429 8.26H2.857l1.065-3.783Z"
        fill="#7BABF7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.435 8.258a1.785 1.785 0 0 1-3.57 0h3.57Z"
        fill="#709BE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.005 8.258a1.785 1.785 0 0 1-3.57 0h3.57Z"
        fill="#3C4BA6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.573 8.258a1.785 1.785 0 1 1-3.57 0h3.57Z"
        fill="#709BE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.144 8.258a1.785 1.785 0 1 1-3.57 0h3.57Z"
        fill="#3C4BA6"
      />
      <path
        d="M15.36 13.093a3.43 3.43 0 0 0-.032-.261H13.38l-.001.841h1.128a.98.98 0 0 1-.413.63l-.001-.005a1.18 1.18 0 0 1-.457.178 1.232 1.232 0 0 1-.955-.202 1.285 1.285 0 0 1-.452-.578l-.02-.055v-.002l.002-.002a1.248 1.248 0 0 1-.001-.803c.062-.183.165-.35.3-.487.316-.328.79-.451 1.226-.32.167.052.32.142.446.263l.38-.38c.067-.068.137-.134.202-.204-.193-.18-.42-.32-.667-.413a2.096 2.096 0 0 0-1.44.005 2.083 2.083 0 0 0-1.306 1.53 2.071 2.071 0 0 0 1.493 2.408c.345.092.711.09 1.059.01.316-.07.608-.222.848-.44.25-.23.43-.537.523-.862.079-.277.107-.565.084-.85Z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="src__com__yext__listingslaunchstorm__public__icons__google-business-profile-logo-small_svg__a"
          x1={3.582}
          y1={11.332}
          x2={16.068}
          y2={11.332}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.03} stopColor="#4079D8" />
          <stop offset={1} stopColor="#4989F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgGoogleBusinessProfileLogoSmall;
